<template>
  <div
    ref="$container"
    class="notification-group"
    :class="{
      'notification-group--top-left': props.position == 'top-left',
      'notification-group--top-right': props.position == 'top-right',
      'notification-group--bottom-left': props.position == 'bottom-left',
      'notification-group--bottom-right': props.position == 'bottom-right',
    }"
    v-bind="$attrs"
    :style="{ 'z-index': zIndex } as any"
  >
    <transition-group name="toast">
      <TirPmNotificationMessage
        v-for="msg of messages"
        :key="msg.id"
        :message="msg"
        :template="$slots.message"
        :z-index="zIndex"
        @close="remove($event)"
      />
    </transition-group>
  </div>
</template>

<script lang="ts" setup>
import TirPmNotificationMessage from "./TirPmNotificationMessage.vue";

import { PropType, onMounted, onUnmounted, ref } from "vue";
import { TirPmNotificationEventBus } from "./utils";

const props = defineProps({
  /**Уникальный идентификатор группы сообщения */
  group: { type: String, default: null },
  /** Позиция выводимого сообщения */
  position: {
    type: String as PropType<"top-left" | "top-right" | "bottom-left" | "bottom-right">,
    default: "bottom-right",
  },
  /**z-index сообщения */
  zIndex: { type: Number, default: 0 },
});
/**События компонента */
const emit = defineEmits(["close", "life-end"]);

const messages = ref<any[]>([]);
const styleElement = ref<any>(null);
const $container = ref<any>(null);
const messageIdx = ref(0);

onMounted(() => {
  TirPmNotificationEventBus.on("add", onAdd);
  TirPmNotificationEventBus.on("remove-group", onRemoveGroup);
  TirPmNotificationEventBus.on("remove-all-groups", onRemoveAllGroups);
});

onUnmounted(() => {
  destroyStyle();
  TirPmNotificationEventBus.off("add", onAdd);
  TirPmNotificationEventBus.off("remove-group", onRemoveGroup);
  TirPmNotificationEventBus.off("remove-all-groups", onRemoveAllGroups);
});

const add = (message: any) => {
  if (message.id == null) message.id = messageIdx.value++;
  messages.value = [...messages.value, message];
};
const remove = (params: any) => {
  let index = -1;

  for (let i = 0; i < messages.value.length; i++) {
    if (messages.value[i] === params.message) {
      index = i;
      break;
    }
  }

  messages.value.splice(index, 1);
  emit(params.type, { message: params.message });
};
const onAdd = (message: any) => {
  if (props.group == message.group) add(message);
};
const onRemoveGroup = (group: any) => {
  if (props.group === group) messages.value = [];
};
const onRemoveAllGroups = () => (messages.value = []);
const destroyStyle = () => {
  if (!styleElement.value) return;
  document.head.removeChild(styleElement.value);
  styleElement.value = null;
};
</script>

<style lang="scss">
.notification-group {
  position: fixed;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.notification-group--top-left {
  top: 1.375rem;
  left: 2.5rem;
}
.notification-group--top-right {
  top: 1.375rem;
  right: 2.5rem;
}
.notification-group--bottom-left {
  bottom: 1.375rem;
  left: 2.5rem;
}
.notification-group--bottom-right {
  bottom: 1.375rem;
  right: 2.5rem;
}
.toast-enter-active,
.toast-leave-active {
  transition: all 0.2s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(1.875rem);
}
</style>
